import { render, staticRenderFns } from "./ActivityPreview.vue?vue&type=template&id=63983b8c&scoped=true&"
import script from "./ActivityPreview.vue?vue&type=script&lang=ts&"
export * from "./ActivityPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityPreview.vue?vue&type=style&index=0&id=63983b8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63983b8c",
  null
  
)

export default component.exports